export default __webpack_public_path__ + "static/media/verify account icon.1da4c55b.png";